<div class="breakdown-content"
     [ngClass]="isNewPage ? 'fullPage-breakdown' : (isFullScreen  ? 'fullScreen-breakdown' : '')">
  <div class="chart-container"  [ngClass]="{ 'fullScreen-chart': isFullScreen }" >
    <div class="chart-section">
      <div class="methodology-header">
        <span class="methodology-text">Grading Methodology</span>
      </div>
      <div class="donut-chart">
        <canvas #chartCanvas width="200" height="200"></canvas>
      </div>
    </div>

    <div class="legend"  [ngClass]="{ 'legend-fullScreen': isFullScreen }" >
      <div class="legend-item" *ngFor="let data of chartData">
        <div class="legend-color" [style.background-color]="data.color"></div>
        <div class="legend-info">
          <span class="legend-name">{{ data.name }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
